// extracted by mini-css-extract-plugin
export default {"cls1":"Loading-HeaderSkeleton_cls1__AvAs0","cls2":"Loading-HeaderSkeleton_cls2__6gmCK Loading-HeaderSkeleton_cls1__AvAs0"};